export const projectsData = [
  {
    name: "Weather Hub",
    picSrc: "./assets/weather-hub.png",
    preview: "https://mokshagnav.github.io/weather-hub/",
    code: "https://github.com/MokshagnaV/weather-hub",
  },
  {
    name: "CRCS-Portal Dashboard",
    picSrc: "./assets/crcs-portal.png",
    preview: "https://mokshagnav.github.io/crcs-portal/",
    code: "https://github.com/MokshagnaV/crcs-portal",
  },
  {
    name: "Resume Builder",
    picSrc: "./assets/resume-builder.png",
    preview: "https://mokshagnav.github.io/resume-builder/",
    code: "https://github.com/MokshagnaV/resume-builder",
  },
  {
    name: "Apartment Management System",
    picSrc: "./assets/ams.png",
    preview: "",
    code: "https://github.com/MokshagnaV/AMS",
  },
  {
    name: "Nike Clone",
    picSrc: "./assets/nike-clone.png",
    preview: "https://nike-clone-mokshagnav.vercel.app/",
    code: "https://github.com/MokshagnaV/nike-clone",
  },
  {
    name: "Many Frontend Practice websites",
    picSrc: "./assets/frontend-practice.png",
    preview: "https://mokshagnav.github.io/frontend-practice",
    code: "https://github.com/MokshagnaV/frontend-practice",
  },
];

export const skillsData = [
  {
    category: "Programming Languages",
    skills: [
      { name: "Java", iconSrc: "./assets/java.svg" },
      { name: "Python", iconSrc: "./assets/python.svg" },
      { name: "JavaScript", iconSrc: "./assets/javascript.svg" },
    ],
  },
  {
    category: "Frameworks",
    skills: [
      { name: "React.js", iconSrc: "./assets/react.svg" },
      { name: "Django", iconSrc: "./assets/django.svg" },
      { name: "Next.js", iconSrc: "./assets/nextjs.svg" },
      { name: "Tailwind CSS", iconSrc: "./assets/tailwindcss.svg" },
    ],
  },
  {
    category: "Tools & Libraries",
    skills: [
      { name: "Material UI", iconSrc: "./assets/material-ui.svg" },
      { name: "Chakra UI", iconSrc: "./assets/chakra-ui.svg" },
      { name: "Webpack", iconSrc: "./assets/webpack.svg" },
      { name: "Visual Studio Code", iconSrc: "./assets/vscode.svg" },
    ],
  },
];

export const educationalDetails = [
  {
    period: "2019-23",
    degree: "Bachelor's Degree (Bachelor of Technology)",
    major: "Computer Science and Engineer",
    institute: "Kamala Institute of Technology and Science",
    scoreType: "CGPA (10) ",
    score: "7.2",
  },
  {
    period: "2017-19",
    degree: "Intermediate (12th Grade)",
    major: "Mathematics Physics Chemistry",
    institute: "Alphores Junior College",
    scoreType: "Percentage",
    score: "95%",
  },
  {
    period: "2016-17",
    degree: "Secondary Schooling (10th Grade)",
    major: "Mathematics Science Social",
    institute: "Rainbow High School",
    scoreType: "CGPA (10) ",
    score: "9.7",
  },
];
